import { render, staticRenderFns } from "./discountCoupon.vue?vue&type=template&id=5859b167&scoped=true&"
import script from "./discountCoupon.vue?vue&type=script&lang=js&"
export * from "./discountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./discountCoupon.vue?vue&type=style&index=0&id=5859b167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859b167",
  null
  
)

export default component.exports